// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/hooks/Container.tsx
// Version: v1.0.1
// Description: Container-Wrapper mit max-width und responsive padding

import type { ReactNode, ElementType, ComponentPropsWithoutRef } from "react";

type Props<T extends ElementType = "div"> = {
  as?: T;                 // z.B. "section" | "header" … oder auch eine Komponente
  className?: string;
  children?: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "className">;

const Container = <T extends ElementType = "div">(
  { as, className = "", children, ...rest }: Props<T>
) => {
  const Comp = (as || "div") as ElementType;           // <- WICHTIG: gültiger JSX-Typ
  return (
    <Comp
      className={`max-w-[1510px] mx-auto px-4 sm:px-6 lg:px-8 w-full ${className}`}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export default Container;
